module.exports = __webpack_public_path__ + "static/img/down_start.08bb5400.png";